import React from 'react';
import { connect } from 'react-redux';

import {
    Text,
} from '@zillow/constellation';

import {
    Col,
    Container,
    Row,
} from '@zillow/zrs-comet';

import Page from 'app/shared/containers/Page';

// Selectors
import { AddressSelectors, AppSelectors, UserSelectors } from 'app/shared/selectors';

class FrontPage extends React.Component {
    static userRequiredBeforeMount = () => true

    constructor(props) {
        super(props);

        this.getWelcomeMessage = this.getWelcomeMessage.bind(this);
    }

    getWelcomeMessage() {
        const {
            isLoggedIn,
            email,
            brand,
        } = this.props;

        if (isLoggedIn && email) {
            return `Hello ${email}, welcome to ${brand} Rental Manager`;
        }
        return `Welcome to ${brand} Rental Manager`;
    }

    render() {
        return (
            <Page className="FrontPage">
                <Container>
                    <Row>
                        <Col>
                            <Text fontType="h3">{this.getWelcomeMessage()}</Text>
                        </Col>
                    </Row>
                </Container>
            </Page>
        );
    }
}

const mapStateToProps = state => ({
    isLoggedIn: UserSelectors.makeIsLoggedIn(state),
    autocomplete: AddressSelectors.makeAutocomplete(state),
    email: UserSelectors.makeEmail(state),
    brand: AppSelectors.makeBrand(state),
});

export default connect(mapStateToProps)(FrontPage);
